import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Checks if the input date is >= a given date (ignoring time).
 *
 * `minDateOrOffset` can be:
 *  - Date: compares against that date
 *  - number: compares against (today + offsetDays)
 *
 * Defaults to today (offset 0).
 */
export function dateGreaterThanEqualValidator(
  minDateOrOffset: Date | number = 0
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    // Empty value
    if (!control.value) {
      return null;
    }

    // Parse input
    const inputDate = new Date(control.value);
    if (Number.isNaN(inputDate.getTime())) {
      return { dateNotGreaterOrEqual: true };
    }
    inputDate.setHours(0, 0, 0, 0);

    // Build compare date
    const compareDate = (() => {
      // If number: interpret as today +/- N days
      if (typeof minDateOrOffset === 'number') {
        const offsetDays = Math.trunc(minDateOrOffset);
        const d = new Date();
        d.setHours(0, 0, 0, 0);
        d.setDate(d.getDate() + offsetDays);
        return d;
      }

      const d = new Date(minDateOrOffset);
      d.setHours(0, 0, 0, 0);
      return d;
    })();

    return inputDate >= compareDate
      ? null
      : {
        dateNotGreaterOrEqual: {
          requiredDate: compareDate
        },
      };

  };
}
